export type MessagePreset = {
  chat_thread_id: string;
  name: string;
  title: string;
  chat_thread_type: string;
  preview: string;
  time: string;
  initials: string;
  avatar_logo: string;
  unread_count: number;
  is_online: boolean;
};

export const messagePresets: MessagePreset[] = [
  {
    chat_thread_id: "msg-1",
    name: "CleanPro Services",
    title: "APT-C8EM3H",
    chat_thread_type: "appointment",
    preview: "Your deep cleaning is confirmed for today.",
    time: "2 min ago",
    initials: "CP",
    avatar_logo: "",
    unread_count: 2,
    is_online: true,
  },
  {
    chat_thread_id: "msg-2",
    name: "GreenScape Gardens",
    title: "QT-7M3K2P",
    chat_thread_type: "quotation",
    preview: "We’ve updated the quotation as per your request.",
    time: "15 min ago",
    initials: "GS",
    avatar_logo: "",
    unread_count: 1,
    is_online: true,
  },
  {
    chat_thread_id: "msg-3",
    name: "FixIt Plumbing",
    title: "APT-F5HN8L",
    chat_thread_type: "appointment",
    preview: "The technician is on the way. ETA 20 mins.",
    time: "1 hr ago",
    initials: "FP",
    avatar_logo: "",
    unread_count: 0,
    is_online: true,
  },
  {
    chat_thread_id: "msg-4",
    name: "ServeNow Support",
    title: "TKT-22841",
    chat_thread_type: "support",
    preview: "Your issue has been resolved. Feel free to re-open if needed.",
    time: "3 hrs ago",
    initials: "SN",
    avatar_logo: "",
    unread_count: 233,
    is_online: true,
  },
  {
    chat_thread_id: "msg-5",
    name: "SparkElectric Co.",
    title: "INQ-9IKD2X",
    chat_thread_type: "inquiry",
    preview: "Please share photos of the wiring for assessment.",
    time: "Yesterday",
    initials: "SE",
    avatar_logo: "",
    unread_count: 0,
    is_online: false,
  },
  {
    chat_thread_id: "msg-6",
    name: "PestGuard Solutions",
    title: "SUB-4820A",
    chat_thread_type: "subscription",
    preview: "Next scheduled visit is on March 5th.",
    time: "2 days ago",
    initials: "PG",
    avatar_logo: "",
    unread_count: 0,
    is_online: false,
  },
];
